<template lang="pug">
.sponsored-plan-interstitial-v1(v-if="ready")
		.container
			.row.mt-5
				.col-md-12
					p.big-text
						| Planning and saving for your child’s college education can seem overwhelming, but with a T. Rowe Price College Savings Plan, highly rated by Morningstar, you don’t have to go it alone. We offer unique tools and resources that can help your children reach their highest potential.
			.row.mt-5
				.col-md-12
					sfc-plan-card(:plan="plan" :user-state="userState" click-source="savings_center_sponsorship&saving_center_t_row_interstitial=true" page="Sponsored Plan Interstitial" :showCount="false" :show-enroll-now-count="true" custom-enroll-now-url="true" hide-plan-link="true")
					img(width="1" height="1" src="https://ad.doubleclick.net/ddm/trackimp/N1951041.115469SAVINGFORCOLLEGE./B32880043.410956979;dc_trk_aid=603637562;dc_trk_cid=227850104;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1?")
			.row.mt-5
				.col-md-12
					p.big-text Reasons to consider this plan:
					ul.big-text.ul-padding
						li Strong Long-Term Performance
						li Available Nationwide
						li Online Gifting
						li Highly rated by Morningstar
					p.big-text Start saving today with as little as $50 per month.
					br
					span.link.mt-5.big-text(href="/savings-center/open-a-plan" @click="emitContinue()") See more plans

		#interstitial-tooltip-container
			b-tooltip.interstitial-tooltip(container="interstitial-tooltip-container" ref="tooltip" target="the-tooltip" placement="top" triggers="blur" :boundary-padding="20" @hidden="closeTooltip()")
				p
					b 5-Cap Ratings:
					|  The 5-Cap Ratings represent our opinion of the attractiveness of a 529 plan based on performance, cost, features and reliability. See our&nbsp;
					a(href="https://www.savingforcollege.com/5-cap-ratings/ratings-criteria" target="_blank") methodology
					|  for more information.
				p
					b Fee Score:
					|  The fee score is derived from the analysis of costs done as part of Savingforcollege.com's 5-Cap Rating. This analysis compares total average asset-based expenses of the plan to other 529 savings plans. See the&nbsp;
					a(href="https://www.savingforcollege.com/5-cap-ratings/ratings-criteria" target="_blank") methodology
					|  for more information.
				p
					b Performance:
					|  The performance score is derived from the analysis of performance as part of Savingforcollege.com's 5-Cap Rating. The analysis considers and compares historical performance of 529 plan portfolios, and the scores shown reflect performance of moderate-risk age-based portfolios for a newborn. See the&nbsp;
					a(href="https://www.savingforcollege.com/5-cap-ratings/ratings-criteria" target="_blank") methodology
					|  for more information.
</template>


<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.sponsored-plan-interstitial-v1
	.ratings
		padding: 0
		margin: 0
		position: relative
		li
			padding: 0
			margin: 0
			display: inline-block
		.about-these-ratings
			position absolute
			bottom: -25px
			left: 0
			color: #2486e7
			text-decoration underline
			font-size: 12px
			cursor pointer
			&.close-text
				left: 40px
	.big-text
		font-size: body-font-size-lg
	.ul-padding
		padding-left: 20px

#interstitial-tooltip-container
	>>>
		.tooltip-inner
			max-width: 600px !important


</style>

<script>

	import SfcPlanCard from "@/common/components/plan/redesign-v1/sfc-plan-card"
	export default {

		components: {
			SfcPlanCard

		},

		props: {
			planSlug: {
				default: null
			}
		},

		data(){

			let classObject = { }

			let userState = this.$store.state.stateFromIp

			classObject[this.planSlug] = true

			return {
				ready: false,
				plan: {},
				classObject,
				userState: userState,
				state: {
					id: ''
				},
				tooltipOpened: false
			}
		},

		methods: {
			emitContinue(){
				this.$emit('continue', true)
			},

			trackEnrollNowClickCallback(){
				this.$emit('track-enroll-now-click')
			},

			trackLearnMoreClickCallback(){
				this.$emit('track-learn-more-click')
			},

			openTooltip () {
				this.$refs.tooltip.$emit('open')
				this.tooltipOpened = true
			},

			closeTooltip () {
				this.$refs.tooltip.$emit('close')
				this.tooltipOpened = false
			}
		},

		async created() {

			const query = `
				query{
					no_graphql_cache()
					plan(slug: "t-rowe-price-college-savings-plan"){
						id
						logo_url
						name
						url
						state
						program_manager
						overall_rating
						performance_rating
						ease_of_use_rating
						savings_success_rating
						resident_benefits
						program_delivery_rating
						plan_details_url
						has_enroll_now
						is_direct_sold
						enroll_now_url
						enroll_now_count
						tracking_pixel_url
						enroll_now_destination_url
						rating_designation
						state_object{
							id
							name
							slug
							sfc_id
						}
					}
				}
			`

			try{
				const response = await this.$httpService.graphql(query)
				this.plan = response.data.plan
				const savingsUser = this.$cookies.get("savings-center-info")
				const state = savingsUser.state

				if (["AK", "MD", "VI", "DC", "NY", "IN"].includes(state.string_id)) {
					this.$emit("close")
					return
				}
				this.ready = true
			}catch(err){
				console.error(err)
			}
		},

	}
</script>
